import { render, staticRenderFns } from "./freightEstimate.vue?vue&type=template&id=c9e3fd1e&scoped=true"
import script from "./freightEstimate.vue?vue&type=script&lang=js"
export * from "./freightEstimate.vue?vue&type=script&lang=js"
import style0 from "./freightEstimate.vue?vue&type=style&index=0&id=c9e3fd1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e3fd1e",
  null
  
)

export default component.exports